import React from 'react';
import ReactPlayer from "react-player/lazy";
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import styles from './DoriVideoPlayer.module.css';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { Paper } from '@mui/material';

const DoriVideoPlayer = ({
  title,
  onClickPrevious,
  onClickNext,
  videoUrl,
  thumbnail,
  disablePrev = false,
  disableNext = false,
  showThumbnailOnly = false
}) => {
  return (
    <Paper elevation={0} className={styles.stationHistVideoContainer}>
      <div className={styles.stationHistPrevNextContainer}>
        <span className={styles.grayBoldFont}>{title ? title : "Instant Replay"}</span>
        <div
          className={styles.prevNextButton}
          style={{ margin: '0 10px 0 auto', color: disablePrev ? 'gray' : '#17B696' }}
          onClick={() => { if (!disablePrev) onClickPrevious() }}
        >
          <SkipPreviousIcon fontSize='small' style={{ color: disablePrev ? 'gray' : '#17B696' }} />
          Prev
        </div>
        <div
          className={styles.prevNextButton}
          style={{ color: disableNext ? 'gray' : '#17B696' }}
          onClick={() => { if (!disableNext) onClickNext() }}
        >
          Next
          <SkipNextIcon fontSize='small' style={{ color: disableNext ? 'gray' : '#17B696' }} />
        </div>
      </div>
      <br />
      {
        videoUrl
          ?
          <ReactPlayer
            url={videoUrl}
            light={thumbnail}
            loop={true}
            controls={true}
            // height={"100%"}
            width={"100%"}
            playbackRate={2}
            // playing={videoSrc || false}
            playing={false}
            muted={true}
          />
          : thumbnail
            ? <div className={styles.noVideoContainer}>
              <img src={thumbnail} style={{ width: '100%', maxHeight: '100%' }} />
            </div>
            : <div className={styles.noVideoContainer}>
              <PlayCircleIcon style={{ color: 'gray' }} fontSize='large' />
            </div>
      }


    </Paper>
  );
}

export default DoriVideoPlayer;